const Footer = () => {
    return (
    <footer>
        <div>
            <p>© 2022 All rights reserved | Paolo Trapu</p>
        </div>
    </footer>
  );
};

export default Footer;

